import React from "react";

import { Text } from "@/styles/reactnative";
import { WorldRankingItems } from "../styles";

const RankingMarketItem = ({ item, index }: any) => {
  const textStyles = {
    background: "transparent",
    paddingBlock: 10,
    width: "13%",
    cursor: "pointer",
    justifyContent: "flex-start",
    paddingLeft: 5,
  };
  return (
    <WorldRankingItems>
      <Text size={14} style={{ ...textStyles, width: "5%" }}>
        {index + 1}
      </Text>
      <Text size={14} style={{ ...textStyles, width: "20%" }}>
        {item?.english_name}
      </Text>
      <Text size={14} style={textStyles}>
        {item?.korean_name}
      </Text>
      <Text size={14} style={textStyles}>
        {item?.market}
      </Text>
      <Text size={14} style={textStyles}>
        {index + 2 * 12}
      </Text>
      <Text size={14} style={textStyles}>
        {index + 2 * 15}
      </Text>
    </WorldRankingItems>
  );
};

export default React.memo(RankingMarketItem);
